import { render } from "./nuevoPedido.vue?vue&type=template&id=28ece10d&scoped=true"
import script from "./nuevoPedido.vue?vue&type=script&lang=js"
export * from "./nuevoPedido.vue?vue&type=script&lang=js"

import "./nuevoPedido.vue?vue&type=style&index=0&id=28ece10d&scoped=true&lang=css"
import "./nuevoPedido.vue?vue&type=style&index=1&id=28ece10d&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ece10d"]])

export default __exports__